<!-- 我的购物车页面组件 -->
<template>
  <div id="cart" class="shoppingCart">
    <div class="cartHeader">
      <svg-icon icon-class="right-shop1" />
      <span>我的购物车</span>
    </div>
    <section class="cartMain">
      <div class="cartMain_hd">
        <ul class="order_lists cartTop">
          <li style="width:610px;" class="list_con">
            <div class="chk">
              <el-checkbox v-model="checkAll" @change="cartchoose($event)" />
              全选
              ({{ allType }}行)
            </div>
            商品信息
          </li>
          <li class="list_amount">数量</li>
          <li class="list_price">单价</li>
          <li class="list_sum">小计</li>
          <li style="padding-left: 4px;" class="list_op">操作</li>
        </ul>
      </div>
      <div v-for="(item, index) in shopList" :key="index" class="cartBox">
        <div class="order_content">
          <span
            v-for="(pro, i) in item.data"
            :key="i"
            style="position: relative;"
          >
            <ul
              :class="pro.choice ? 'order_lists selected_order' : 'order_lists'"
            >
              <li class="list_con">
                <!-- :disabled="setupQuery(pro)" -->
                <el-checkbox
                  id="checkbox_2"
                  v-model="pro.choice"

                  class="son_check"
                  @change="choose($event, item, pro)"
                />
                <div class="list_img">
                  <el-image
                    ref="myImage"
                    style="width:70px;height:70px;"
                    :src="pro.fstockCoverImgPath || require('../../../assets/images/no-pic.jpg')"
                    :preview-src-list="[pro.fstockCoverImgPath]"
                  />
                </div>
                <div class="list_text">
                  <div class="shopText">{{ pro.text }}</div>
                  <div class="hover-box">
                    <!-- <div style="color:#000;" class="shoppinpai">名称：{{ pro.fmasterStockName }}</div>
                  <div class="shoppinpai">品牌：{{ pro.fmarkName }}</div>
                  <div class="shoppinpai">规格：{{ pro.fspecification }}</div> -->
                    <div class="stock-info" @click="toDetail(pro)">
                      {{ pro.fmasterStockName }}
                    </div>
                    <div class="codeBox">
                      订货编码：
                      <span class="copyCode" @click.stop="copyCode(pro.FShortCode,0)">
                        <span class="codeInfo">{{ pro.FShortCode | filterCode }}</span>
                        <i class="el-icon-document-copy" />
                      </span>
                    </div>
                    <div class="codeBox">
                      <template>
                        需方编码：
                        <span class="copyCode" @click.stop="copyCode(pro.FDemandStcokCode,1,pro.isEdit)">
                          <!-- <el-tooltip
                          class="item"
                          effect="dark"
                          :content="pro.FDemandStcokCode"
                          placement="top-start"
                        > -->
                          <span v-if="!pro.isEdit" class="codeInfo">{{ pro.FDemandStcokCode }}</span>
                          <i v-if="!pro.isEdit" class="el-icon-document-copy" />
                          <span v-if="!pro.isEdit" class="edit btn" @click.stop="pro.isEdit = true">修改</span>
                          <el-input v-if="pro.isEdit" v-model="pro.FDemandStcokCode" style="height:20px;" size="mini" placeholder="请输入需方编码" />
                          <span v-if="pro.isEdit" class="confirm btn" @click.stop="cfmEdit(pro)">保存</span>
                        <!-- </el-tooltip> -->

                        </span>
                      </template>
                    </div>
                  </div>
                </div>
              </li>
              <li class="list_amount" style="display:block;">
                <!-- :disabled="!pro.FStockQuanty||pro.FStockQuanty<pro.fquanty" -->
                <el-input-number
                  :ref="'number'+i"
                  :key="pro.key"
                  v-model="pro.fquanty"
                  :precision="pro.FQuantyDecimal"
                  :min="pro.min"
                  :max="99999"
                  @input.native="handleInput(pro, i)"
                  @change="handleChange($event, pro)"
                />
                <!-- <template v-if="setupQuery(pro)">
                  <div style="color:red;text-align: center;width:142px;line-height: 32px;">库存不足</div>
                </template> -->

              <!-- <span v-if="pro.fmeasurement">{{ pro.fmeasurement }}</span> -->
              </li>
              <li class="list_price">
                <p v-if="FPriceShow" class="price">
                  ￥
                  <span v-html="stockPrice(pro.fStockPrice,18,pro.FTPriceDecimal)" />
                  <span v-if="pro.fmeasurement">/{{ pro.fmeasurement }}</span>
                </p>
                <p v-else id="noShowPrice">
                  <span>￥</span>价格不可见
                </p>
              </li>
              <li class="list_sum">
                <p v-if="FPriceShow" class="sum_price">
                  ￥
                  <span v-html="stockPrice(pro.subtotal,18,2)" />
                </p>
                <p v-else id="noShowPrice">
                  <span>￥</span>价格不可见
                </p>
              </li>
              <li
                style="z-index: 99;"
                class="list_op"
                @mouseover="onmouseover(pro)"
                @mouseout="onmouseout(pro)"
                @click="deleteShop(pro)"
              >
                <!-- <svg-icon :icon-class="pro.show ? 'delete-red' : 'delete-hui'" /> -->
                <span style="z-index:999;" class="delBtn">删除</span>
              </li>
            </ul>
            <!-- <div v-if="!pro.FStockQuanty" class="shade">
              <div class="outOfStock">
                无货
              </div>
            </div> -->
          </span>

        </div>
      </div>
      <div v-if="!shopList.length" class="noList">
        暂无数据...
      </div>

    </section>
    <section class="model_bg" />
    <!--底部-->
    <div class="bar-wrapper">
      <div class="bar-left">
        <div class="barChange">
          <el-checkbox id="all" v-model="checkAll" class="whole_check" @change="cartchoose($event)" />
          全选
          （{{ allType }}行）
        </div>
        <div class="barDelete" @click="allDetele">删除</div>
        <div class="barDelete" @click="allCollect">加入收藏</div>
      </div>
      <div class="bar-right">
        <div class="Statistics">
          <!-- <div class="totalMoney">
            总金额: <span v-if="FPriceShow"><i>￥</i>{{ allMoney.toFixed(2) }}</span>
            <span v-else id="noShowPrice"><span>￥</span>价格不可见</span>
          </div> -->
          <div class="piece">
            <!-- 已选<span>{{ allType }}</span>种， -->
            已选<span>{{ allnum }}</span>件商品
          </div>
        </div>
        <div :class="fpurchaseMode ? 'calBtn no-pay' : 'calBtn'" @click="goAccount(shopList)">{{ submitText }}
        </div>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="allDeletedialog" width="30%" center :before-close="handleClose">
      <span>确定要删除选中商品吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="allDeletedialog = false">取 消</el-button>
        <el-button type="primary" @click="onconfirm()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// import func from 'vue-editor-bridge'
import request from '@/utils/request.js'
import debounce from '@/utils/timeout.js'
import {
  deleteCards,
  selectCards,
  updateCards
} from '@/api/shop.js'
export default {
  name: 'ShoppingCart',
  filters: {
    filterCode(val) {
      if (val) {
        return val.slice(0, 9)
      } else {
        return ''
      }
    }
  },
  data() {
    return {
      fpurchaseMode: null,
      submitText: null,
      shopList: [], // 购物车里店铺的数据
      fetchData: {
        list: [{
          check: false, // 店铺选中状态
          choose: 0, // 商品选中个数
          products: [{
            pro_id: 101,
            text: '东成 手电钻DCZC02-24 18V充电式冲击钻',
            price: 480,
            num: 1,
            img: require('@/assets/images/shop.jpg'),
            pinpai: '东成',
            guige: 'DCZC02-24',
            sum: 480,
            checked: false // 商品选中状态
          },
          {
            pro_id: 102,
            text: '东成 手电钻DCZC02-24 18V充电式冲击钻',
            price: 680,
            num: 1,
            img: require('@/assets/images/shop.jpg'),
            pinpai: '东成',
            guige: 'DCZC02-24',
            sum: 680,
            checked: false
          }
          ]
        }],
        allsum: 0, // 总计价格
        allnum: 0 // 总计数量
      },
      num: 1,
      shopNum: 0,
      allDeletedialog: false, // 删除全部商品弹窗
      checkAll: false, // 全选选中状态
      allchoose: 0, // 店铺选中个数
      // allnum: 0 // 总计选中数量
      // allMoney: 0
      selectList: [],
      FPriceShow: 0,
      updataLoading: false
    }
  },
  computed: {
    setupQuery() {
      const That = this
      return function(items) {
        return !items.FStockQuanty || items.FStockQuanty < items.fquanty
      }
    },
    allMoney() {
      var sum = 0
      this.shopList.forEach((item) => {
        item.data.forEach((i) => {
          // let dataMoney = Number;
          // if (item.fOutDayLimit == 0) {
          //   i.dataMoney = i.fNoAPPrice;
          // } else if (item.fOutDayLimit == 1) {
          //   i.dataMoney = i.fOnMAPPrice;
          // } else if (item.fOutDayLimit == 2) {
          //   i.dataMoney = i.fTwMAPPrice;
          // } else if (item.fOutDayLimit == 3) {
          //   i.dataMoney = i.FThMAPPrice;
          // } else if (item.fOutDayLimit == 4) {
          //   i.dataMoney = i.FFoMAPPrice;
          // } else if (item.fOutDayLimit == 5) {
          //   i.dataMoney = i.FFiMAPPrice;
          // }
          if (i.choice) {
            sum += i.fquanty * i.fStockPrice
          }
        })
      })
      //   this.fetchData.list.forEach((item) => {
      //     item.products.forEach((val) => {
      //       if (val.checked) {
      //         sum += val.price * val.num
      //       }
      //     })
      //   })
      return sum
    },
    allType() {
      var num = 0
      this.shopList.forEach((item) => {
        item.data.forEach((i) => {
          if (i.choice) {
            num++
          }
        })
      })
      return num
    },
    allnum() {
      var num = 0
      this.shopList.forEach((item) => {
        item.data.forEach((i) => {
          if (i.choice) {
            num += i.fquanty
          }
        })
      })
      return num.toFixed(4)
    }
  },
  watch: {
    $route() {
      this.getSelectCards()
      this.checkAll = false
      window.addEventListener((scroll) => {
        console.log(scroll)
      })
    }
  },
  // 组件挂载完毕发请求
  mounted() {
    // 获取购物车数据方法
    const userInfor = localStorage.getItem('userInfo')
    userInfor && (this.FPriceShow = JSON.parse(userInfor).FPriceShow)
    this.getSelectCards()
    const UserInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.fpurchaseMode = UserInfo.fpurchaseMode
  },
  methods: {
    countDecimal(val) {
      let min = '0.'
      for (let i = 1; i < val; i++) {
        min += '0'
      }
      return Number(min + '1')
    },
    stockPrice(val, size,FTPriceDecimal) {
      let price = val;
      if(FTPriceDecimal!=undefined||FTPriceDecimal!=null)price = val.toFixed(FTPriceDecimal);
      else price=val.toFixed(2);
      price=String(parseFloat(price||0));
      if(price.indexOf(".")>-1){
        const arr =price.split('.')
        return `<span style='font-size:${size}px;'>${arr[0]}</span>.${arr[1]}`
      }else{
        return `<span style='font-size:${size}px;'>${price}</span>`
      }
      
    },
    copyCode(val, n, e) {
      if (n && e) {
        return
      }
      const str = n ? '需方编码' : '订货编码'
      const input = document.createElement('input')
      document.body.appendChild(input)
      const value = n ? val : (val ? val.slice(0, 9) : val)
      input.setAttribute('value', value)
      input.setAttribute('create', 1)
      input.select()
      document.execCommand('Copy')
      this.$notify({
        message: `${str}已成功复制`,
        type: 'success',
        position: 'bottom-left',
        duration: 1000
      })
      var list = document.getElementsByTagName('input')
      var inputList = Array.prototype.slice.call(list)
      inputList.forEach((item) => {
        if (item.getAttribute('create'))document.body.removeChild(item)
      })
    },
    cfmEdit(t) {
      const jsonStr = {
        stockId: t.FMasterStockID,
        demandStcokCodeId: t.demandStcokCodeId || 0,
        fdemandstcokcode: t.FDemandStcokCode
      }
      const params = new URLSearchParams()
      params.append('jsonStr', JSON.stringify(jsonStr))
      request({
        url: '/mall/demandstock/updateDemandStockCode',
        method: 'post',
        params
      })
        .then(res => {
          if (res.result) {
            t.isEdit = false
          } else {
            this.$message.error(res.msg)
          }
        })
    },
    toDetail(item) {
      this.$router.push({
        path: '/store/details',
        query: {
          mallstorestockFId: item.fStoreStockId,
          shopid: item.fstoreId
        }
      })
    },
    getFloat(number, n) {
      n = n ? parseInt(n) : 0
      if (n <= 0) {
        return Math.round(number)
      }
      number = Math.round(number * Math.pow(10, n)) / Math.pow(10, n) // 四舍五入
      number = Number(number).toFixed(n) // 补足位数
      return number
    },
    choosetrue(item, pro) {
      pro.checked = true // 将商品选中状态改为true
      ++item.choose === item.products.length ? (item.check = true)
        : '' // 这里执行了两部，选中商品数量先+1，再与该店铺商品数量比较，如果相等就更改店铺选中状态为true
      item.check
        ? ++this.allchoose === this.fetchData.list.length
          ? (this.checkAll = true)
          : (this.checkAll = false)
        : '' // 如果店铺选中状态改为true，选中店铺数量先+1，再与店铺数量比较，如果相等就更改全选选中状态为true
      this.fetchData.allnum += pro.num
      this.fetchData.allsum += pro.sum
    },
    choosefalse(item, pro) {
      pro.checked = false // 将商品选中状态改为false
      --item.choose // 选中商品数量-1
      if (item.check) {
        // 如果店铺是被选中的，更改店铺选中状态
        item.check = false
        --this.allchoose // 并且选中店铺数量-1
      }
      this.checkAll = false // 无论之前全选的状态，将其改为false就行
      this.fetchData.allnum -= pro.num
      this.fetchData.allsum -= pro.sum
    },
    // findFalse(item, b) {
    //   if (b) {
    //     const allChoice = this.shopList.find(i => i.choice === false)
    //     allChoice === undefined ? this.checkAll = true : this.checkAll = false
    //   } else {
    //     const choice = item.find(i => i.choice === false)
    //     return choice
    //   }
    // },
    findFalse(item, b) {
      if (b) {
        const allChoice = this.shopList.find((i) => i.choice === false)
        allChoice === undefined
          ? (this.checkAll = true)
          : (this.checkAll = false)
      } else {
        const choice = item.find((i) => i.choice === false)
        return choice
      }
    },
    choose(e, item, pro) {
      const Choice = this.findFalse(item.data, false)
      Choice === undefined ? (item.choice = true) : (item.choice = false)
      this.findFalse('', true)
      //   pro.checked ? this.choosetrue(item, pro) : this.choosefalse(item, pro)
    }, // 这里是绑定到html上的方法，取反是由于你在触发方法的时候取的是之前的状态
    shoptrue(item) {
      item.forEach((pro) => {
        pro['choice'] = true
      })
    }, // 循环店铺中的商品，先筛选出目前没选中的商品，给它执行choosetrue函数
    shopfalse(item) {
      item.forEach((pro) => {
        pro['choice'] = false
      })
    }, // 循环店铺中的商品，先筛选出目前被选中的商品，给它执行choosefalse函数
    shopchoose(e, item) {
      item.choice ? this.shoptrue(item.data) : this.shopfalse(item.data)
      this.findFalse('', true)
    },
    cartchoose(e) {
      this.shopList.forEach(item => {
        item.choice = e
        item.data.forEach(t => {
          t.choice = e
        })
      })
      //   this.checkAll
      //     ? this.shopList.forEach((item) => {
      //       let next = false
      //       const select = item.data.filter(items => {
      //         const nexts = !items.FStockQuanty || items.FStockQuanty < items.fquanty
      //         if (nexts)next = true
      //         return !nexts
      //       })
      //       if (next) {
      //         item.choice = false
      //         this.$nextTick(() => {
      //           this.checkAll = false
      //         })
      //       } else {
      //         item.choice = true
      //       }

    //       this.shoptrue(select)
    //     })
    //     : this.shopList.forEach((item) => {
    //       item.choice = false
    //       this.shopfalse(item.data)
    //     })
    }, // 根据取反后的状态进行相应的店铺按钮操作
    // 计数器数值改变的时候
    handleInput(t, i) {
      t.subtotal = this.$refs['number' + i][0].displayValue * t.fStockPrice
    },
    async handleChange(value, pro) {
      if (!value) this.$set(pro, 'fquanty', pro.min)
      pro.subtotal = pro.fquanty * pro.fStockPrice
      pro.key++
      debounce(() => {
        if ((pro.fquanty * pro.fStockPrice).toFixed(2) == 0) {
          this.$message.warning('商品金额不能为0，请重新输入')
          return
        }
        const {
          fid,
          fquanty,
          fStoreStockId
        } = pro
        const obj = {
          fid,
          fquanty,
          fStoreStockId
        }
        this.updataLoading = true
        updateCards(obj).then((res) => {
          this.updataLoading = false
          if (res.result) {
            this.$parent.$parent.$parent.$refs.headerSearch.getComput()
            this.$parent.$parent.$parent.$refs.rightNav.getComput()
          }
        })
          .catch(() => {
            this.updataLoading = false
          })
      }, 200)
    },
    handleCheckAllChange(val) {
      // this.isIndeterminate = false
    },
    onmouseover(pro) {
      this.$set(pro, 'show', true)
    },
    onmouseout(pro) {
      this.$set(pro, 'show', false)
    },
    // 获取购物车数据
    async getSelectCards() {
      this.checkAll = false
      this.shopList = []
      const res = await selectCards()
      //   this.shopList = res
      this.submitText = res.fIsApproval ? '提交申请' : '结算'
      for (const key in res) {
        if (key !== 'fIsApproval' && key !== 'fOutDayLimit') {
          res[key].forEach((item) => {
            var min="0.",FQuantyDecimal=item.FQuantyDecimal||0;
            for(var dml=0;dml<FQuantyDecimal-1;dml++){
                min+="0"
            }
            if(FQuantyDecimal>0){
              min=min+"1";
            }else{
              min=1;
            }
            
            item['choice'] = false
            item['isEdit'] = false
            item['min'] =min;
            item['key'] = 1
            item['subtotal'] = item.fquanty * item.fStockPrice
          })
          const obj = {}
          obj['storeName'] = key
          obj['data'] = res[key]
          obj['choice'] = false
          obj['fOutDayLimit'] = res.fOutDayLimit
          this.shopList.push(obj)
        }
      }
      //   this.fetchData.list = res
    },
    // 删除
    deleteShop(val) {
      // let params = new URLSearchParams()
      // params.append('fids',fid.toString())
      // await deleteCards(params)
      // this.getSelectCards ()
      this.allDeletedialog = true
      this.onconfirm(val.fid)
    },
    // 全部删除
    allDetele() {
      this.selectList = []
      this.shopList.forEach((item) => {
        item.data.forEach((obj) => {
          if (obj.choice === true) {
            this.selectList.push(obj.fid)
          }
        })
      })
      this.selectList.length
        ? (this.allDeletedialog = true)
        : this.$message.warning('请选择要删除的商品')
    },
    allCollect() {
      const arr = []
      this.shopList.forEach((item) => {
        console.log(item)
        item.data.forEach((obj) => {
          if (obj.choice === true) {
            arr.push(obj.fmallstorestockId)
            // arr.push(obj)
          }
        })
      })
      if (!arr.length) return this.$message.warning('请选择收藏的商品！')
      const params = new URLSearchParams()
      params.append('mallstoreStockId', arr.toString())
      params.append('mallstoreId', 0)
      params.append('operationType', 1)
      const url = `/mall/stockmanage/mallstorestock/collectStock/${arr.toString()}/0/1`
      request({
        url,
        method: 'get'
      })
        .then(res => {
          if (!res.result) {
            this.$message.error(res.msg)
          } else {
            this.$notify({
              message: res.msg,
              type: 'success',
              position: 'bottom-left',
              duration: 1000
            })
          }
        })
    },
    onconfirm(val) {
      const params = new URLSearchParams()
      if (!val) {
        params.append('fids', this.selectList.toString())
      } else {
        params.append('fids', val.toString())
      }
      deleteCards(params).then((res) => {
        if (res.msg == '删除成功') {
          this.$message({
            message: res.msg,
            type: 'success'
          })
          this.$parent.$parent.$parent.$refs.headerSearch.getComput()
          this.$parent.$parent.$parent.$refs.rightNav.getComput()
          this.getSelectCards()
        } else {
          this.$message({
            message: res.msg,
            type: 'warning'
          })
          this.getSelectCards()
        }
      })
      this.allDeletedialog = false
    },
    handleClose() {},
    // 点了去结算
    goAccount(val) {
      if (this.fpurchaseMode) return
      const datamap = []
      val.map((item) => {
        item.data.map((it) => {
          // && it.FStockQuanty
          if (it.choice == true) {
            datamap.push({
              id: it.fstoreId,
              num: it.fquanty,
              storeId: it.fStoreStockId,
              // FQuantyDecimal:it.FQuantyDecimal,
              FTPriceDecimal:it.FTPriceDecimal

            })
          }
        })
      })
      if (!datamap.length) {
        return this.$message.warning('请选择要结算的商品')
      }
      const dataobj = JSON.stringify(datamap)
      const isShoping = Number(this.$parent.$parent.$parent.$refs.headerSearch.isShoping)
      this.$nextTick(() => {
        this.$router.push({
          path: '/submitOrder/submitOrderList',
          query: {
            source: 2,
            data: dataobj,
            isShoping
          }
        })
      })
    }
  }
}
</script>
<style lang='scss'>
.list_amount {
    .el-input-number .el-input__inner {
        padding: 0 30px;
    }
}

</style>
<style lang="scss" scoped>
    .shoppingCart {
        width: 100%;
        margin: 30px 0 80px 0;
        background-color: #fff;

        #noShowPrice {
            display: inline-block;
            height: 26px;
            line-height: 26px;
            padding: 0 5px;
            font-size: 14px !important;
            color: #ec2631;
            font-weight: 400 !important;

            //   background: #fbd3d5;
            span {
                font-size: 12px !important;
                font-weight: 400 !important;
            }
        }

        .cartHeader {
            font-size: 20px;
            color: #333333;
            padding-bottom: 20px;
            background: #F3F3F3;
            font-weight: bold;

            .svg-icon {
                margin-right: 6px;
            }
        }

        .cartMain_hd {
            // width: 1200px;
            height: 46px;
            background: #fff;
            border-radius: 5px;
            font-size: 14px;
            color: #666;
            line-height: 46px;
            padding: 0 20px;
        }

        .order_lists {
            display: flex;
            // justify-content: space-between;
            // align-items: center;
            caret-color: rgba(0, 0, 0, 0);
        }

        .order_lists {
            .list_con {
                width: 625px;
                display: flex;

                #checkbox_2 {
                    z-index: 999;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 34px;
                    margin-left: 11px;
                }

                .chk {
                    width: 116px;

                    .el-checkbox {
                        margin-right: 10px;
                    }
                }
            }

            .list_amount {
                width: 200px;
                text-align: left;
            }

            .list_price {
                width: 150px;
                text-align: left;
                // .price {
                //     font-size: 12px;
                // }
            }

            .list_sum {
                width: 150px;
                text-align: left;
            }

            .list_op {
                width: 80px;
                text-align: left;
            }
        }

        .noList {
            height: 450px;
            line-height: 450px;
            text-align: center;
        }

        .cartBox {
            .shop_info {
                padding: 30px 10px 11px;
                display: flex;
                align-items: center;
                font-size: 14px;
                font-weight: 500;
                color: #333333;

                .shopChoice {
                    margin-right: 20px;
                }

                .all_check {
                    line-height: 9px;
                }
            }

            .selected_order {
                background: #f5f7fa;
                border-bottom-color: #fff !important;
            }

            .order_content {

                .shade {
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 1220px;
                    height: 100px;
                    background: rgba($color: #fff, $alpha: 0.5);
                    .outOfStock {
                        position: absolute;
                        left: 56px;
                        top: 24px;
                        width: 48px;
                        height: 48px;
                        line-height: 48px;
                        border-radius: 50%;
                        background: rgba(0,0,0,0.5);;
                        text-align: center;
                        font-size: 14px;
                        color: #fff;
                    }
                }

                //   border: 1px solid #cdcdcd;
                li {
                    padding: 12px 0;
                }

                .order_lists:hover {
                    background: #f5f7fa;
                    // border-bottom-color: #fff;
                }

                .order_lists {
                    padding-right: 10px;
                    height: 100px;
                    // padding-right: 25px;
                    border-bottom: 1px solid rgba(0, 3, 20, .05);

                    // &:last-child {
                    //   border-bottom: unset;
                    // }
                    ::v-deep .el-input__inner {
                        caret-color: #000;
                    }

                    .list_con {
                        display: flex;

                        .list_img {
                            width: 66px;
                            height: 66px;
                            border-radius: 5px;
                            overflow: hidden;
                            margin-right: 20px;
                        }

                        .list_text {
                            width: 406px;
                            margin-right: 80px;

                            .shopText {
                                font-size: 14px;
                                color: #333;
                            }

                            .shoppinpai {
                                height: 22px;
                                line-height: 22px;
                                font-size: 14px;
                                color: #999;
                                display: -webkit-box;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                word-break: break-all;
                                -webkit-box-orient: vertical;
                                -webkit-line-clamp: 1; //此处为行数，可以改为任意数字

                                .spanitem {
                                    font-weight: bold;
                                }
                            }

                            .hover-box {
                                .codeBox {
                                    display: flex;
                                    font-size: 12px;
                                    color: #666;
                                    min-height: 21px;
                                    line-height: 21px;

                                    .copyCode {
                                        display: flex;
                                        line-height: 21px;
                                        cursor: pointer;
                                        ::v-deep .el-input--mini .el-input__inner {
                                            height: 20px;
                                            line-height: 20px;
                                        }
                                        .btn {
                                            width: 40px;
                                            height: 20px;
                                            line-height: 20px;
                                            text-align: center;
                                            border-radius: 2px;
                                            margin-left: 10px;
                                        }
                                        .edit {
                                            background: #FFFFFF;
                                            color: #777777;
                                            border: 1px solid #EFEFEF;
                                        }
                                        .confirm {
                                            background: #EC212D;
                                            color: #fff;
                                            border: 1px solid #EC212D;
                                        }
                                    }

                                    i {
                                        line-height: 21px;
                                        margin-left: 6px;
                                    }

                                    .codeInfo {
                                        display: inline-block;
                                        max-width: 134px;
                                        overflow: hidden;
                                        white-space: nowrap;
                                        text-overflow: ellipsis;
                                        -o-text-overflow: ellipsis;
                                    }
                                }

                                .stock-info {
                                    flex: 1;
                                    cursor: pointer;
                                    font-size: 12px;
                                    font-weight: bold;
                                    line-height: 17px;
                                    height: 34px;
                                    display: -webkit-box;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    word-break: break-all;
                                    -webkit-box-orient: vertical;
                                    -webkit-line-clamp: 2;

                                    .self-support {
                                        display: inline-block;
                                        width: 35px;
                                        height: 18px;
                                        line-height: 18px;
                                        text-align: center;
                                        border-radius: 3px;
                                        background: #ec2631;
                                        color: #fff;
                                        font-size: 12px;
                                    }
                                }

                                .stock-info:hover {
                                    color: #ec2631;
                                }
                            }
                        }
                    }

                    .list_amount {
                        display: flex;
                        font-size: 14px;
                        color: #333;

                        .amount_box {
                            width: 115px;
                            height: 30px;
                            border: 1px solid #d2d2d2;
                            border-radius: 2px;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            line-height: 30px;
                            text-align: center;
                            margin-right: 10px;

                            .reSty {
                                width: 28px;
                                height: 28px;
                                background-color: #f1f1f1;
                            }

                            .reduce {
                                border-right: 1px solid #d2d2d2;
                            }

                            .plus {
                                border-left: 1px solid #d2d2d2;
                            }

                            .sum {
                                width: 55px;
                                text-align: center;
                            }
                        }
                    }

                    .list_price {
                        font-size: 14px;
                        color: #333;
                    }

                    .list_sum {
                        font-size: 14px;
                        color: #e00224;
                        font-weight: bold;
                    }

                    .list_op {
                        font-size: 14px;
                        color: #666;
                        cursor: pointer;

                        &:hover {
                            color: #ec2631;
                        }
                    }
                }
            }
        }

        .bar-wrapper {
            position: fixed;
            z-index: 999999;
            background: #fff;
            position: -webkit-sticky;
            bottom: 0;
            width: 1220px;
            height: 60px;
            line-height: 60px;
            // border: 1px solid #cdcdcd;
            margin-top: 30px;
            padding-left: 10px;

            .bar-left {
                float: left;
                display: flex;

                .barChange {
                    font-size: 14px;
                    color: #333;
                }

                .barDelete {
                    caret-color: transparent;
                    font-size: 14px;
                    color: #999;
                    margin-left: 33px;
                    cursor: pointer;
                }
                .barDelete:hover {
                    color: #ec2631;
                }
            }

            .bar-right {
                float: right;
                display: flex;

                .Statistics>div {
                    // line-height: 1;
                    text-align: right;
                }

                .piece {
                    height: 60px;
                    line-height: 60px;
                    font-size: 14px;
                    color: rgba(0, 3, 20, .45);

                    span {
                        padding: 0 3px;
                        color: #333333;
                    }
                }

                .totalMoney {
                    height: 24px;
                    margin-top: 9px;
                    text-align: center;
                    font-size: 16px;
                    color: #333;
                    position: relative;

                    i {
                        font-style: normal;
                        font-size: 18px;
                    }

                    span {
                        font-size: 24px;
                        font-family: DIN;
                        font-weight: 500;
                        color: #e00224;
                        //   padding: 0 10px;
                    }

                    // &::before {
                    //   content: "";
                    //   width: 1px;
                    //   height: 30px;
                    //   background: #000000;
                    //   opacity: 0.1;
                    //   position: absolute;
                    //   top: 8px;
                    //   left: 0;
                    // }
                }

                .calBtn {
                    width: 180px;
                    height: 64px;
                    margin-top: -1px;
                    margin-left: 25px;
                    background: #ec212d;
                    text-align: center;
                    line-height: 64px;
                    font-size: 18px;
                    color: #fff;
                    cursor: pointer;
                }

                .no-pay {
                    cursor: not-allowed !important;
                    background: #f5f7fa;
                    color: #c0c4cc;
                    border: 1px solid #cdcdcd;
                }
            }
        }
    }

    input[type="number"]::-webkit-inner-spin-button,
    input[type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    .list_amount {
        .el-input-number {
            width: 142px;
            height: 32px;
            line-height: 32px;

            ::v-deep .el-input-number__increase,
            ::v-deep .el-input-number__decrease {
                background-color: #f1f1f1;
                width: 30px;
                height: 30px;
            }

            ::v-deep .el-input-number__increase {
                border-radius: 0 2px 2px 0;
            }

            ::v-deep .el-input-number__decrease {
                border-radius: 2px 0 0 2px;
            }

            ::v-deep .el-input__inner {
                height: 32px;
                line-height: 32px;
                border-radius: 2px;
            }
        }
    }
</style>
